import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiClientService, SmartMovingValidators } from '@smartmoving/sm-shared-lib';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'sm-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  submitting = false;
  showError = false;
  showSuccess = false;

  constructor(
      private readonly route: ActivatedRoute,
      private readonly router: Router,
      private readonly apiClient: ApiClientService,
      private readonly notifications: NotificationsService,
      private readonly formBuilder: FormBuilder
  ) {
  }

  async ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    const userId = this.route.snapshot.queryParams['userId'];
    // Only multi-region reset links carry it; the API routes perform-reset to that region.
    const region = this.route.snapshot.queryParams['region'];

    if (!token || !userId) {
      this.notifications.warn('Reset failed', 'Please try resetting your password again.');
      await this.router.navigateByUrl('/forgot-password');
    }

    this.resetPasswordForm = this.formBuilder.group({
      userId: [userId],
      token: [token],
      ...(region ? { region: [region] } : {}),
      newPassword: ['', SmartMovingValidators.createStandardPasswordValidators()],
      newPasswordConfirmation: ['', Validators.required]
    });
  }

  async submit() {
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    const form = this.resetPasswordForm.value;
    if (form.newPassword !== form.newPasswordConfirmation) {
      this.notifications.error('Error!', 'You must enter the same password twice.');
      return;
    }

    await this.apiClient.postAll([{ url: 'forgot-password/perform-reset', body: form }], x => this.submitting = x);
    this.showSuccess = true;
  }
}

